module.exports = __webpack_public_path__ + "static/media/email-blue.3acf7020.png";